export const MAX_FEEDBACK_FILES = 3;
export const MAX_FEEDBACK_FILE_SIZE_MB = 5;
export const FEEDBACK_FILE_TYPES = '.png,.jpg,.jpeg,.pdf';
export const FEEDBACK_CATEGORIES_ORDER = [
  'GENERAL_INQUIRY',
  'BUG',
  'IMPROVEMENT',
  'OTHER'
];
